;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"2ab4b3591b9bfb06f19ec459b9595faaaafbaa6f"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/nextjs/0.0.1_1618";import * as Sentry from "@sentry/nextjs";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import { publicConfig } from "./src/config";
import { getSentryEnvName } from "./src/sentry";

Sentry.init({
	release: publicConfig.RELEASE,
	dsn: publicConfig.SENTRY_DSN,
	tracesSampleRate: publicConfig.SENTRY_TRACING_RATE,
	sampleRate: publicConfig.SENTRY_SAMPLING_RATE,
	environment: getSentryEnvName(),
	denyUrls: [
		/cookielaw\.org/i,
		/otBannerSdk/i,
		/E-v1\.js/i,
		/web_widget\/messenger/i,
		/fast\.wistia\.com/i,
	],
});
